import { OktaAuth } from '@okta/okta-auth-js';
import { Config } from 'packages/lib/config';
// Helpful info:
// https://confluence.ci.motional.com/confluence/display/ML/Auth+Service+Module
export interface User {
  email?: string;
  name?: string;
}

export interface AuthResult {
  user: User;
  accessToken: string;
  expiresAt: string;
  idToken: string;
  scopes: string[];
  issuer: IssuerName;
}

export const hasChrome = (): boolean =>
  !!(navigator.userAgent.indexOf('Chrome') !== -1);

export interface AuthService {
  userHasScopes: (scopes: Array<string>, tries?: number) => Promise<boolean>;
  userScopeIncludesOneOf: (
    scopes: Array<string>,
    tries?: number
  ) => Promise<boolean>;
  user: () => Promise<User | null>;
  signOut: () => Promise<void>;
  getTokenSilently: () => Promise<AuthResult | null>;
  redirectToLogin: () => Promise<void>;
  authClient: () => Promise<OktaAuth>;
}

export type IssuerName = keyof Config['auth'];
